module.exports = __webpack_public_path__ + "img/Emoji.95a7524f.svg";